import { PAGE_PARAMS } from '../T3/_params';
import * as AJAX from '../T3/ajax';

import {
  BLOCKER_ID,
  showSiteBlocker,
  hideSiteBlocker,
  getTransitionTime,
  showElementTransition,
  hideElementTransition,
} from '../components/popup';

document.addEventListener('DOMContentLoaded', function() {
  var $siteAlerts = $('.site-alert');
  var $alertClose = $('.site-alert .btn.btn--close');

  const alertCloser = $('.btn--close');

  let siteAlertProminent = $('.site-popup--prominent');

  if (siteAlertProminent.length > 0) {
    const SITE_BLOCKER = $(BLOCKER_ID);
    const POPUP_ID = '#' + siteAlertProminent[0].id;

    const TRANSITION_SPEED = 250;
    showSiteBlocker(SITE_BLOCKER, TRANSITION_SPEED, POPUP_ID);
    showElementTransition(siteAlertProminent, TRANSITION_SPEED);
  }

  // Click on close x
  alertCloser.click(function(e) {
    e.preventDefault();
    let caller = $(e.target);
    if (caller.parents('.site-popup').length !== 1 && caller.parents('.site-alert').length !== 1) {
      return false;
    }

    if (caller.parents('.site-popup').length === 1) {
      closeAlert(caller, caller.parents('.site-popup'));
      return true;
    }
    closeAlert(caller, caller.parents('.site-alert'));
    return true;
  });

  function onSuccess(params, caller, data) {
    hideSiteBlocker($(BLOCKER_ID), 250);
    hideElementTransition($(caller.id), 250);
  }

  // Close popup function
  function closeAlert(_caller, alertContainer) {
    alertContainer.removeClass('active');

    let alertId = alertContainer.data('identifier');

    let params = PAGE_PARAMS;
    params.plugin = 'deactivateSiteAlert';
    params.extension = 'tx_vdthemekid';
    params.typeNum = 787839;
    params.alertId = alertId;

    AJAX.call(params, alertContainer, onSuccess);
  }

  // Expose closePopup to be callable programmatically
  window.closeAlert = closeAlert;
});
